import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
//import NavDropdown from "react-bootstrap/NavDropdown";

import "./Navbar.css";


function CollapsibleExample() {
  return (
    <>
      <Navbar collapseOnSelect expand="lg" className=" bg-dark topbar d-none d-lg-block d-xl-block">
        <Container fluid className="top-bar-container">
          {/* <Navbar.Brand href="#home">
            <img src="/Images/Logo.svg" alt="Logo" />
          </Navbar.Brand> */}
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="me-auto">
              <Nav.Link href="https://www.spedireadesso.com/spedizioni-nazionali.html">Spedizioni Nazionali</Nav.Link>
              <Nav.Link href="https://www.spedireadesso.com/spedizioni-internazionali.html">Spedizioni Internazionali</Nav.Link>


              {/* <NavDropdown title="Dropdown" id="collapsible-nav-dropdown">
              <NavDropdown.Item href="#action/3.1">Action</NavDropdown.Item>
              <NavDropdown.Item href="#action/3.2">
                Another action
              </NavDropdown.Item>
              <NavDropdown.Item href="#action/3.3">Something</NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item href="#action/3.4">
                Separated link
              </NavDropdown.Item>
            </NavDropdown> */}
            </Nav>
            <Nav className="topbar-nav-rhs">
              <Nav.Link
                eventKey={1}
                href="https://www.spedireadesso.com/modulo-spedisci-busta.html"
                title="modulo acquista francobollo"
              >
                <img
                  src={`${process.env.PUBLIC_URL}/Images/Navbar/icon-1.svg`}
                  alt="modulo acquista francobollo"
                />
              </Nav.Link>
              <Nav.Link
                eventKey={2}
                href="https://spedireadesso.com/modulo-preventivo-postale/"
                title="Modulo preventivo posta pubblicataria"
              >
                <img
                  src={`${process.env.PUBLIC_URL}/Images/Navbar/icon-2.svg`}
                  alt="Modulo preventivo posta pubblicataria"
                />
              </Nav.Link>
              <Nav.Link
                eventKey={3}
                href="https://www.spedireadesso.com/modulo-ordine-spedizione.html?&format_id=2"
                title="modulo ordine spedizione busta"
              >
                <img
                  src={`${process.env.PUBLIC_URL}/Images/Navbar/icon-3.svg`}
                  alt="modulo ordine spedizione busta"
                />
              </Nav.Link>
              <Nav.Link
                eventKey={4}
                href="https://www.spedireadesso.com/modulo-ordine-spedizione.html?&format_id=1"
                alt="modulo ordine spedizione pacco"
              >
                <img
                  src={`${process.env.PUBLIC_URL}/Images/Navbar/icon-4.svg`}
                  alt="modulo ordine spedizione pacco"
                />
              </Nav.Link>

              <Nav.Link
                eventKey={5}
                href="https://www.spedireadesso.com/modulo-ordine-spedizione.html?&format_id=6"
                title="modulo ordine spedizione valigia"
              >
                <img
                  src={`${process.env.PUBLIC_URL}/Images/Navbar/icon-5.svg`}
                  alt="modulo ordine spedizione valigia"
                />
              </Nav.Link>
              <Nav.Link
                eventKey={6}
                href="https://www.spedireadesso.com/modulo-ordine-spedizione.html?&format_id=4"
                title="modulo ordine spedizione bicicletta"
              >
                <img
                    src={`${process.env.PUBLIC_URL}/Images/Navbar/icon-6.svg`}
                  alt="modulo ordine spedizione bicicletta"
                />
              </Nav.Link>
              <Nav.Link
                eventKey={7}
                href="https://www.spedireadesso.com/modulo-ordine-spedizione.html?&format_id=3"
                title="modulo ordine spedizione pallet"
              >
                <img
                    src={`${process.env.PUBLIC_URL}/Images/Navbar/icon-7.svg`}
                  alt="modulo ordine spedizione pallet"
                />
              </Nav.Link>
              <Nav.Link
                eventKey={8}
                href="https://www.spedireadesso.com/modulo-richiesta-preventivo.html"
                title="modulo richiesta preventivo"
              >
                <img src={`${process.env.PUBLIC_URL}/Images/Navbar/icon-8.svg`}
                     alt="modulo richiesta preventivo" />
              </Nav.Link>

              <Nav.Link
                  eventKey={9}
                  href="https://www.spedireadesso.com/cerca-spedizioni.html"
                  title="cerca spedizioni"
              >
                <img src={`${process.env.PUBLIC_URL}/Images/Navbar/icon-9.svg`}
                     alt="cerca spedizioni" />
              </Nav.Link>



            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      <Navbar collapseOnSelect expand="lg" className="navbar-btm navbarposta">
        <Container fluid className="btmbar-container">
          <div className="info-icon">
            <i className="bi bi-info-square"></i>
          </div>
          <Navbar.Brand href="https://www.spedireadesso.com">
            <div>
              <img src={`${process.env.PUBLIC_URL}/Images/Logo.svg`}
                   alt="SpedireAdesso"  className="logo-img"/>
            </div>
          </Navbar.Brand>

          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="me-auto">
            
            </Nav>
            <Nav className="bottombar">
              <Nav.Link eventKey={1} href="https://www.spedireadesso.com" alt="spedireadesso">
               Servizi di Spedizione
              </Nav.Link>
              <Nav.Link eventKey={1} href="https://www.spedireadesso.com/assistenza-spedizioni/come-spedire.html" alt="Come spedire">
                Come spedire
              </Nav.Link>
              <Nav.Link eventKey={4} href="https://www.spedireadesso.com/blog.html" alt="spedireadesso blog">
                Blog
              </Nav.Link>
              <Nav.Link eventKey={5} href="https://www.spedireadesso.com/contatti.html" alt="spedireadesso contatti">
                Contatti
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
}

export default CollapsibleExample;
